import { getAllAdvancements } from "./dict/getAdvancement";
import { getAllInjuries } from "./dict/getInjuries";
import { getFighterSkills } from "./dict/getSkills";
import { getAllFactions } from "./faction/getAllFactions";
import { addProfile } from "./fighter-weapon/addProfile";
import { addUpgrade } from "./fighter-weapon/addUpgrade";
import { getUpgradesAndProfiles } from "./fighter-weapon/getUpgradesAndProfiles";
import { removeProfile } from "./fighter-weapon/removeProfile";
import { removeUpgrade } from "./fighter-weapon/removeUpgrade";
import { addEquipment } from "./fighter/addEquipment";
import { addInjury } from "./fighter/addInjury";
import { addSkill } from "./fighter/addSkill";
import { addWeapon } from "./fighter/addWeapon";
import { createFighter } from "./fighter/createFighter";
import { deleteFighters } from "./fighter/deleteFighters";
import { editCharacteristics } from "./fighter/editCharacteristics";
import { getFighter } from "./fighter/getFighter";
import { getIncreaseLevel } from "./fighter/getIncreaseLevelInfo";
import { increaseLevel } from "./fighter/increaseLevel";
import { removeEquipment } from "./fighter/removeEquipment";
import { removeInjury } from "./fighter/removeInjury";
import { removeSkill } from "./fighter/removeSkill";
import { removeWeapon } from "./fighter/removeWeapon";
import { getFighterTypes } from "./fighterType/getFighterTypes";
import { createTeam } from "./team/createTeam";
import { deleteTeam } from "./team/deleteTeam";
import { editTeam } from "./team/editTeam";
import { getNavigationInfo } from "./team/getNavigationInfo";
import { getRecentTeams as getRecentTeams } from "./team/getRecentTeams";
import { getTeam } from "./team/getTeam";
import { getTeamCash } from "./team/getTeamCash";
import { getTradingPost } from "./tradingPost/getTradingPost";
import { getCurrentUser } from "./user/getCurrentUser";
import { getUserTeams } from "./user/getUserTeams";
import { login } from "./user/login";
import { logout } from "./user/logout";
import { register } from "./user/register";
import {getAllTraits} from "./dict/Trait/getAllTraits";
import {createTrait} from "./dict/Trait/createTraitResult";
import {updateTrait} from "./dict/Trait/updateTraitResult";
import {deleteTrait} from "./dict/Trait/deleteTrait";
import {getAllUpgrades} from "./dict/upgrade/getAllUpgrades";
import {createUpgrade} from "./dict/upgrade/createUpgrade";
import {deleteUpgrade} from "./dict/upgrade/deleteUpgrade";
import {updateUpgrade} from "./dict/upgrade/updateUpgrade";
import {createWeapon} from "./dict/DictWeapon/createWeapon";
import {updateWeapon} from "./dict/DictWeapon/updateWeapon";
import {deleteWeapon} from "./dict/DictWeapon/deleteWeapon";
import {getWeaponById} from "./dict/DictWeapon/getWeaponById";
import {getAllWeapons} from "./dict/DictWeapon/getAllWeapons";
import {getAllEquipmentCategories} from "./dict/EquipmentCategory/getAllEquipmentCategories";
import {createEquipmentCategory} from "./dict/EquipmentCategory/createEquipmentCategory";
import {updateEquipmentCategory} from "./dict/EquipmentCategory/updateEquipmentCategory";
import {deleteEquipmentCategory} from "./dict/EquipmentCategory/deleteEquipmentCategory";
import {getAllFighterTypesDict} from "./dict/FighterType/getAllFighterTypesDict";
import {createFighterType} from "./dict/FighterType/createFighterType";
import {updateFighterType} from "./dict/FighterType/updateFighterType";
import {deleteFighterType} from "./dict/FighterType/deleteFighterType";
import {getAllEquipmentDict} from "./dict/Equipment/getAllEquipmentDict";
import {createEquipment} from "./dict/Equipment/createEquipment";
import {updateEquipment} from "./dict/Equipment/updateEquipment";
import {deleteEquipment} from "./dict/Equipment/deleteEquipment";
import {getAllXpSources} from "./dict/XpSource/getAllXpSources";
import {createXpSource} from "./dict/XpSource/createXpSource";
import {updateXpSource} from "./dict/XpSource/updateXpSource";
import {deleteXpSource} from "./dict/XpSource/deleteXpSource";
import {getAllSkillBranches} from "./dict/Skill/getAllSkillBranches";
import {createSkillBranch} from "./dict/Skill/createSkillBranch";
import {updateSkillBranch} from "./dict/Skill/updateSkillBranch";
import {deleteSkillBranch} from "./dict/Skill/deleteSkillBranch";
import {getFighterXpHistory} from "./fighter/getFighterXpHistory";
import {addFighterXp} from "./fighter/addFighterXp";
import {editFighterNotes} from "./fighter/editFighterNotes";
import {editFighterInfo} from "./fighter/editFighterInfo";
import {deleteFighterXp} from "./fighter/deleteFighterXp";
import { SaveOrder } from "./team/saveFighterOrder";
import { getLeaderboard } from "./team/getLeaderboard";

export const Api = {
  dict: {
    getAllInjuries: getAllInjuries,
    getAllAdvancements: getAllAdvancements,
    getAllTraits: getAllTraits,
    createTrait: createTrait,
    updateTrait: updateTrait,
    deleteTrait: deleteTrait,
    getAllUpgrades: getAllUpgrades,
    createUpgrade: createUpgrade,
    deleteUpgrade: deleteUpgrade,
    updateUpgrade: updateUpgrade,
    createWeapon: createWeapon,
    updateWeapon: updateWeapon,
    deleteWeapon: deleteWeapon,
    getWeaponById: getWeaponById,
    getAllWeapons: getAllWeapons,
    getAllEquipmentCategories: getAllEquipmentCategories,
    createEquipmentCategory: createEquipmentCategory,
    updateEquipmentCategory: updateEquipmentCategory,
    deleteEquipmentCategory: deleteEquipmentCategory,
    getAllFighterTypesDict: getAllFighterTypesDict,
    createFighterType: createFighterType,
    updateFighterType: updateFighterType,
    deleteFighterType: deleteFighterType,
    getAllEquipmentDict: getAllEquipmentDict,
    createEquipment: createEquipment,
    updateEquipment: updateEquipment,
    deleteEquipment: deleteEquipment,
    getAllXpSources: getAllXpSources,
    createXpSource: createXpSource,
    updateXpSource: updateXpSource,
    deleteXpSource: deleteXpSource,
    getAllSkillBranches: getAllSkillBranches,
    createSkillBranch: createSkillBranch,
    updateSkillBranch: updateSkillBranch,
    deleteSkillBranch: deleteSkillBranch,
  },
  user: {
    getCurrentUser: getCurrentUser,
    login: login,
    logout: logout,
    register: register,
    getUserTeams: getUserTeams,
  },
  factions: {
    getAllFactions: getAllFactions,
  },
  team: {
    createTeam: createTeam,
    getRecentTeams: getRecentTeams,
    deleteTeam: deleteTeam,
    getTeam: getTeam,
    getNavigationInfo: getNavigationInfo,
    editTeam: editTeam,
    getTeamCash: getTeamCash,
    saveOrder: SaveOrder,
    getLeaderboard: getLeaderboard,
  },
  fighterType: {
    getFighterTypes: getFighterTypes,
  },
  fighter: {
    createFighter: createFighter,
    getIncreaseLevel: getIncreaseLevel,
    increaseLevel: increaseLevel,
    deleteFighters: deleteFighters,
    getFighter: getFighter,
    addEquipment: addEquipment,
    addWeapon: addWeapon,
    removeEquipment: removeEquipment,
    removeWeapon: removeWeapon,
    addInjury: addInjury,
    removeInjury: removeInjury,
    addSkill: addSkill,
    removeSkill: removeSkill,
    getFighterSkills: getFighterSkills,
    editCharacteristics: editCharacteristics,
    getFighterXpHistory: getFighterXpHistory,
    addFighterXp: addFighterXp,
    editFighterNotes: editFighterNotes,
    editFighterInfo: editFighterInfo,
    deleteFighterXp: deleteFighterXp,
  },
  tradingPost: {
    getTradingPost: getTradingPost,
  },
  fighterWeapon: {
    getUpgradesAndProfiles: getUpgradesAndProfiles,
    addProfile: addProfile,
    removeProfile: removeProfile,
    addUpgrade: addUpgrade,
    removeUpgrade: removeUpgrade
  },
};
